import { CurrencyModel } from "../../redux/reducers/static-data.reducers";
import { WarehouseModel } from "../shared/models/order/warehouse.model";

export function calculateForLand(weight: number, volume: number, senderWarehouse: WarehouseModel, currency: CurrencyModel, rate?: number) {
    const priceForKilo = getPriceForKilo(weight, senderWarehouse);
    // const convertedPriceForKilo = rate ? priceForKilo * rate : priceForKilo;
    const priceForVolume = getVolumeMultiplier(volume, currency?.currencyId || 2);

    let price = Math.ceil(weight * priceForKilo);

    const minPrice = (currency?.name["4"] as string) === 'eur' ? 4.5 : 500; // TODO: get shipping minimum

    if (price < minPrice) {
        price = minPrice;
    }

    const volumetricPrice = Math.ceil(priceForVolume * priceForKilo);

    return { price, volumetricPrice };
}

export function getVolumeMultiplier(volume: number, currencyId: number): number {
    const sizeCategory = volume > 360000
        ? (volume > 511999
            ? 3
            : 2)
        : 1;

    const divider = currencyId === 3
        ? 1454
        : sizeCategory === 1
            ? 6000
            : (sizeCategory === 2
                ? 7000
                : 8000)

    return volume / divider;
}

function getPriceForKilo(weight: number, senderWarehouse: WarehouseModel): number {
    // if (senderCountryId === ARMENIA_COUNTRY_ID) {
    //     if (weight < 1.45) {
    //         return 5000;
    //     } else if (weight < 150) {
    //         return 3500;
    //     } else {
    //         return 3000;
    //     }
    // } else {
    //     if (weight < 3.75) {
    //         return 16;
    //     } else if (weight < 150) {
    //         return 4.5;
    //     } else {
    //         return 4;
    //     }
    // }
    return senderWarehouse.shippingPriceByLand || 3000;
}